import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Input, Row } from 'reactstrap';
import useAuth from '../../hooks/useAuth';
import RequireUserType from '../../routes/middleware/requireUserType';
import { getPurchaseOrderListReq } from '../../service/purchaseService';
import { setBreadcrumbItems } from '../../store/Breadcrumb/actions';
import { changePreloader } from '../../store/actions';
import {
  MODULES_ENUM,
  PERMISSIONS_ENUM,
  USER_TYPES_ENUM,
} from '../../utility/constants';
import { formatDate } from '../../utility/formatDate';
import { formatNumberWithCommasAndDecimal } from '../Invoices/invoiceUtil';
import DropdownMenuBtn from './DropdownMenuBtn';
import OrderStatusRenderer from './OrderStatusRenderer';

const ViewPurchaseOrder = (props) => {
  document.title = 'All Purchase Orders';
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'))
  const userType = user?.userType


  const autoSizeStrategy = {
    type: 'fitGridWidth',
  };
  const paginationPageSizeSelector = [25, 50, 100];
  const { auth,selectedBranches,selectedWarehouses } = useAuth();
  const [rowData, setRowData] = useState([]);
  const [paginationPageSize, setPaginationPageSize] = useState(100);
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [sortData, setSortData] = useState({
    key: 'createdAt',
    order: 'desc',
  });

  const timerRef = useRef(null);
  const gridRef = useRef();
  const [status, setStatus] = useState('');

  const redirectToViewPage = (id) => {
    let path = `/purchase-orders/${id}`;
    setTimeout(() => {
      navigate(path, id);
    }, 300);
  };

  const handleViewClick = (id) => {
    redirectToViewPage(id.order_id);
  };

  useEffect(() => {
    props.setBreadcrumbItems('Purchase Orders', breadcrumbItems);
  }, []);

  useEffect(() => {
    let body = {
      page: page,
      limit: paginationPageSize,
      branchId:selectedBranches,
      warehouseId:selectedWarehouses
    };
    if (searchValue) {
      body.search = searchValue;
    }
    if (sortData && sortData.key) {
      body.sort = sortData;
    }
    if (status) {
      body.status = status;
    }

    getListOfRowData(body)
  }, [page, paginationPageSize, searchValue, sortData, status,selectedBranches,selectedWarehouses]);
  const getListOfRowData = useCallback(async (body) => {
    if (rowData[(page - 1) * paginationPageSize]) {
      dispatch(changePreloader(true));
    }
    dispatch(changePreloader(true));




    try {

      const response = await getPurchaseOrderListReq(body);

      const orders = response?.data || [];


      const res = orders.map((order) => ({
        order_id: order._id,
        purchaseOrderNumber: order.purchaseOrderNumber || '-',
        poDate:order.poDate,
        poDateFormatted:formatDate(order.poDate),
        client_name: order.clientId?.name || '-',
        approvedAt: order.approvalHistory[0]?.approvedAt,
        approvedAtFormatted: formatDate(order.approvalHistory[0]?.approvedAt),
        total: order.grandTotal,
        POStatus: order.POStatus || order.status,
        salesOrderNumber: order.salesOrderNumber || '-',
        salesOrderId: order.salesOrderId || '-',
        purchaseRequisitionNumber:
          order.purchaseRequisitionNumber || '-',
        customerId: order?.zohoCustomerId,
        branch_name: order?.billing?.branchName || '-'
      }));
      

      const emptyObjects = Array.from(
        { length: paginationPageSize },
        () => null
      );

      let filledRows;

      if (res.length < paginationPageSize) {
        filledRows = [...res];
      } else {
        filledRows = [...res, ...emptyObjects];
      }

      const newData = [...rowData];
      newData.splice(
        (page - 1) * paginationPageSize,
        paginationPageSize,
        ...filledRows
      );
      setRowData(newData);
    } catch (error) {

      console.error(
        'Error fetching purchase orders:',
        error
      );

      setRowData([]);

    } finally {

      dispatch(changePreloader(false));
    }
  },
    [page, paginationPageSize, searchValue, sortData]
  );

  const redirectToEditPage = (id) => {
    let path = `/purchase-orders/${id.order_id}/edit`;
    setTimeout(() => {
      navigate(path);
    }, 300);
  };
  const headerTemplate = (props) => {
    const { handleSort, data } = props;

    return (
      <button
        onClick={() => handleSort(data, sortData)}
        style={{ background: 'transparent', border: 'none' }}
      >
        <span style={{ fontWeight: 600 }}>
          {data?.displayName}&nbsp;

          {sortData?.key === data?.column?.userProvidedColDef?.field && (
            <i
              className={
                sortData?.order === "asc"
                  ? "mdi mdi-arrow-up"
                  : "mdi mdi-arrow-down"
              }
            />
          )}
        </span>
      </button>
    );
  };
  const handleSort = (data, sortData) => {
    if (data.column.userProvidedColDef.field === sortData?.key) {
      setSortData({
        ...sortData,
        order: sortData?.order === "asc" ? "desc" : "asc",
      });
    } else {
      setSortData({
        key: data.column.userProvidedColDef.field,
        order: "desc",
      });
    }

    setPage(1);
    setRowData([]);
  };

  const handleDeleteResponse = (response) => {
    if (response.success === true) {
      notify('Success', response.message);
    } else {
      notify('Error', response.message);
    }
    getListOfRowData({
      page: page,
      limit: paginationPageSize,
      search: searchValue,
      sort: sortData,
      status: status
    });
  };

  const handleEditClick = (id) => {
    redirectToEditPage(id);
  };

  const onPaginationChanged = useCallback((event) => {
    // Workaround for bug in events order
    let pageSize = gridRef.current.api.paginationGetPageSize();
    setPaginationPageSize(pageSize);

    if (pageSize !== paginationPageSize) {
      setPaginationPageSize(pageSize);
    }
    const newPage = gridRef.current.api.paginationGetCurrentPage() + 1;

    if (page !== newPage) {
      setPage(newPage);
    }
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value?.trim() || '';
    setInputValue(value);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setRowData([]);
      setPage(1);
      setSearchValue(value);
    }, 2000);
  };

  const breadcrumbItems = [
    { title: 'Dashboard', link: '/dashboard' },
    { title: 'Purchase Orders', link: '#' },
  ];

  const columnDefs = [
    {
      headerName: 'Order Date',
      field: 'poDate',
      sortable: true,
      minWidth: 150,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      headerName: 'PO No.',
      field: 'purchaseOrderNumber',
      minWidth: 150,
      sortable: false,
      headerComponent: headerTemplate,
      headerComponentParams: (props) => ({
        handleSort: handleSort,
        data: props,
        sortData,
      }),
      cellRenderer: (params) => {
        const id = params.data?.order_id;
        const number = params.data?.purchaseOrderNumber;

        const isClickable = number && number.trim() !== '' && number.trim() !== '-';

        return (
          <span
            style={{
              cursor: id ? 'pointer' : 'default',
              color: id ? '#007bff' : 'inherit',
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (id) navigate(`/purchase-orders/${id}`);
            }}
          >
            {number || '-'}
          </span>
        );
      },
    },
   ...(userType === "client"
    ? [
        {
          headerName: 'Approved Date',
          field: 'approvedAt',
          sortable: true,
          minWidth: 150,
          valueFormatter: (params) => formatDate(params.value),
        },
      ]
    : []),
    {
      headerName: 'PR No.',
      field: 'purchaseRequisitionNumber',
      minWidth: 150,
      sortable: false,
      cellRenderer: (params) => {
        const id = params.data?.order_id;
        const number = params.data?.purchaseRequisitionNumber;

        const isClickable = number && number.trim() !== '' && number.trim() !== '-';

        return (
          userType === 'client' ? (

            <span
              style={{
                cursor: isClickable ? 'pointer' : 'default',
                color: isClickable ? '#007bff' : 'inherit',
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (isClickable && id) {
                  navigate(`/purchase-requisitions/${id}`);
                }
              }}
            >
              {isClickable ? number : '-'}
            </span>
          ) : (
            <span
              style={{
                color: '#007bff'
              }}
            >
              {number}
            </span>
          )

        );
      },
    },
    {
      headerName: 'SO No.',
      field: 'salesOrderNumber',
      minWidth: 140,
      sortable: false,
      headerComponent: headerTemplate,
      headerComponentParams: (props) => ({
        handleSort: handleSort,
        data: props,
        sortData,
      }),
      cellRenderer: (params) => {
        const salesOrderId = params.data?.salesOrderId;
        const number = params.data?.salesOrderNumber;

        const isClickable = number && number.trim() !== '' && number.trim() !== '-';

        return (
          <span
            style={{
              cursor: number ? 'pointer' : 'default',
              color: number ? '#007bff' : 'inherit',
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (salesOrderId) {
                navigate(`/order/${salesOrderId}`);
              }
            }}
          >
            {number || '-'}
          </span>
        );
      },
    },
    {
      headerName: 'Branch',
      field: 'branch_name',
      minWidth: 250,
      sortable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      tooltipValueGetter: (p) => p.value,
      headerTooltip: "Branch",
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      headerName: "Order Status",
      field:"POStatus",
      minWidth: 150,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
      headerComponent: headerTemplate,
      headerComponentParams: (props) => ({
        handleSort: handleSort,
        data: props,
        sortData,
      }),
      tooltipValueGetter: (p) => p.value,
      headerTooltip: "Order Status",
      cellStyle: {
        textAlign: "left",
      },
      cellRenderer: (params) => (
        <OrderStatusRenderer value={params.value} type="po" />
      ),
    },
    {
      headerName: 'Client',
      field: 'client_name',
      minWidth: 150,
      sortable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      tooltipValueGetter: (p) => p.value,
      headerTooltip: 'Client',

    },
    {
      headerName: 'Total Amount',
      field: 'total',
      minWidth: 150,
      sortable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      tooltipValueGetter: (p) => p.value,
      headerTooltip: 'Total Amount',
      valueFormatter: (params) =>
        formatNumberWithCommasAndDecimal(params.value) + ' /-',
    },
    {
      headerName: 'Action',
      field: 'action',
      sortable: false,
      width: 100,
      cellClass: 'actions-button-cell',
      cellRenderer: DropdownMenuBtn,
      cellRendererParams: {
        handleViewClick: handleViewClick,
      },
      floatingFilterComponentParams: { suppressFilterButton: true },
      tooltipValueGetter: (p) => p.value,
      headerTooltip: 'Actions',
    },
  ];

  const clientColumnDefs = columnDefs.filter(
    (colDef) => colDef.headerName !== 'Client',
  );

  const clientUserColumnDefs = columnDefs.filter(
    (colDef) => colDef.headerName !== 'Total Amount'&&colDef.headerName !== 'Client',
  );

  const notify = (type, message) => {
    if (type === 'Error') {
      toast.error(message, {
        position: 'top-center',
        theme: 'colored',
      });
    } else {
      toast.success(message, {
        position: 'top-center',
        theme: 'colored',
      });
    }
  };
  return (
    <>
      <div className="all-items">
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <div className="button-section">
                  <div className="button-right-section">
                    <div className="invoice-search-box">
                      <div
                        className="search-box position-relative"
                        style={{
                          width:
                            auth.userType === USER_TYPES_ENUM.ADMIN
                              ? '20rem'
                              : '14rem',
                        }}
                      >
                        <Input
                          type="text"
                          value={inputValue}
                          onChange={handleInputChange}
                          className="form-control rounded border"
                          placeholder={
                            auth.userType === USER_TYPES_ENUM.ADMIN
                              ? 'Search by Client or Order Number'
                              : 'Search by Order Number'
                          }
                        />
                        <i className="mdi mdi-magnify search-icon"></i>

                      </div>

                    </div>
                    <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                      <div>
                      <select value={status} onChange={(e) => setStatus(e.target.value)}
                        className="form-select form-control rounded border" >

                        <option value="">All status</option>
                        <option value="sent">Sent</option>
                        <option value="accepted">Accepted</option>
                        <option value="declined">Declined</option>
                      </select>

                     </div>
                    </RequireUserType>
                    <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                      <div>
                      <select value={status} onChange={(e) => setStatus(e.target.value)}
                        className="form-select form-control rounded border" >

                        <option value="">All status</option>
                        <option value="published">Unsent</option>
                        <option value="sent">Sent</option>
                        <option value="accepted">Approved</option>
                        <option value="rejected">Rejected</option>
                        <option value="declined">Declined</option>
                      </select>

                     </div>
                    </RequireUserType>
                  </div>

                </div>


                <div
                  className="ag-theme-quartz"
                  style={{
                    height: '550px',
                    width: '100%',
                  }}
                >
                  <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                    <AgGridReact
                      ref={gridRef}
                      rowData={rowData}
                      columnDefs={columnDefs}
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      paginationPageSizeSelector={paginationPageSizeSelector}
                      autoSizeStrategy={autoSizeStrategy}
                      onPaginationChanged={onPaginationChanged}
                      animateRows={true}
                      reactiveCustomComponents
                      suppressRowClickSelection={true}
                    />
                  </RequireUserType>
                  <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                    <AgGridReact
                      ref={gridRef}
                      rowData={rowData}
                      columnDefs={
                        auth?.permissions?.some(
                          (p) =>
                            p.module === MODULES_ENUM.ORDERS &&
                            [
                              PERMISSIONS_ENUM.READ,
                              PERMISSIONS_ENUM.CREATE,
                            ].every((perm) => p.operations.includes(perm)),
                        )
                          ? clientColumnDefs
                          : auth?.permissions?.some(
                            (p) =>
                              p.module === MODULES_ENUM.ORDERS &&
                              p.operations.includes(PERMISSIONS_ENUM.READ),
                          )
                            ? clientUserColumnDefs
                            : []
                      }
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      paginationPageSizeSelector={paginationPageSizeSelector}
                      autoSizeStrategy={autoSizeStrategy}
                      onPaginationChanged={onPaginationChanged}
                      animateRows={true}
                      reactiveCustomComponents
                      suppressRowClickSelection={true}
                    />
                  </RequireUserType>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>

    </>
  );

};

export default connect(null, { setBreadcrumbItems })(ViewPurchaseOrder);
